import { PersistorService } from 'core/services';

export class ListOptions {
  page: number;
  pages: number;
  limit: number;
  sort: string;
  search: string | Map<string, string>;
  filters: Map<string, string>;
  total: number;
  docs: any[];
  active: boolean;
  aggregates: [string];
  elementsName: string;
  hidePaginator: boolean;
  showFilterRow: boolean;
  populate: string;
  selectable: boolean;
  selected: boolean;
  hideResendEmail?: boolean;
  hideEmptyLabel?: boolean;
  clientId?: string;
  locale?: string;
  routeLoadName?: string;

  static getValues(id, listTrail: any = {}) {
    const options = PersistorService.get(id);
    if (options) {
      return options;
    }

    return this.getDefaultValues(listTrail);
  }

  static getDefaultValues(listTrail: any = {}): ListOptions {
    const { filters = {}, showFilterRow, selected } = listTrail;

    return {
      page: 1,
      pages: 1,
      limit: 10,
      sort: null,
      search: null,
      filters: new Map(Object.entries(filters)),
      total: 0,
      active: !(filters && Object.keys(filters).length),
      docs: [],
      aggregates: null,
      elementsName: '',
      hidePaginator: false,
      showFilterRow: !!showFilterRow,
      populate: null,
      selectable: false,
      selected
    };
  }

  constructor(opts: any) {
    Object.assign(this, opts);
  }
}
